import * as actionTypes from './actionTypes';

/**
* @desc actions for candidate review reducer
* @version
* @author  Lakshmikanth
* @return action and parameters
*/
export const getGroupedTalentPool = ( jobTitleId,user ) => {
  return {
    type: actionTypes.GET_GROUP_TALENTPOOL,
    jobTitleId: jobTitleId,
    user:user
  };
};

export const setGroupedTalentPool = ( talentPool ) => {
  return {
    type: actionTypes.SET_GROUP_TALENTPOOL,
    talentPool: talentPool
  };
};

export const handlePoolPriorityChange = ( candidateIdList, jobId ) => {
  return {
    type: actionTypes.UPDATE_CANDIDATE_PRIORITY,
    candidateIdList: candidateIdList,
    jobId: jobId
  };
};

export const signOutCandidateReview = () => {
  return {
    type: actionTypes.COGNITO_LOGOUT
  };
};




// WEBPACK FOOTER //
// ./src/store/actions/candidateReview.js